import util from '../util';
import Text from './text';
import $ from "jquery";
import MenuObject from "./menu-object";

export function fixComponentLineHeight($cmp) {
    const defaultLineHeight = util.getComponentLineHeight($cmp);
    const $ps = $cmp.find('p');

    $ps.each(() => {
        $ps.children().each(function () {
            const $kid = $(this);
            if ($kid.get(0).style.fontSize !== '') {
                $kid.get(0).style.fontSize = '';
            } else if (!!$kid.get(0).tagName && $kid.get(0).tagName.toLowerCase() === 'strong') {
                $kid.children().each(function () {
                    const $kidsKid = $(this);
                    if ($kidsKid.get(0).style.fontSize !== '') {
                        $kidsKid.get(0).style.fontSize = '';
                    }
                })
            }
        })
    });

    $ps.each(function () {
        Text.fixLineHeight($(this), defaultLineHeight);
    });
}

export function setParagraphLineHeight($p) {
    const $cmp = $p.parents('[data-component="text"]');
    const elementLineHeight = util.getComponentLineHeight($cmp);

    $p.css('height', '');
    const height = $p.height();
    const lineHeight = parseFloat($p.css('line-height'));

    $p.css({
        height: `${Math.round(height / lineHeight) * elementLineHeight}em`
    })
}

export function setLineHeights($component) {
    if ($component) {
        if (util.isGroup($component)) {
            $component?.find('[data-component="text"]').each(function () {
                fixComponentLineHeight($(this));
            });
        } else {
            fixComponentLineHeight($component);
        }
    } else {
        const $pages = $('#pages');
        const $components = $pages.find('[data-component="text"]');
        $components.each(function () {
            fixComponentLineHeight($(this));
        });

        const $mos = $pages.find('.menu-object');
        $mos.each(function () {
            MenuObject.setHeights($(this));
        })
    }
}
